/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/Palm_3.glb -o src/models/plants/Palm3.jsx --transform --draco 
Files: public/Palm_3.glb [7.02MB] > /Users/radek/Documents/GIthub/CoffeeCoded/coffeecoded/src/models/plants/assets/plants/Palm_3-transformed.glb [357.92KB] (95%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import modelUrl from '../../assets/plants/Palm_3-transformed.glb'

export function Model(props) {
  const { nodes, materials } = useGLTF(modelUrl)
  return (
    <group {...props} dispose={null}>
      <group position={[0.025, 0, -0.053]} rotation={[Math.PI / 2, 0, -0.391]} scale={0.01}>
        <mesh geometry={nodes.BezierCurve003.geometry} material={materials.PalmTrunk} />
        <mesh geometry={nodes.BezierCurve003_1.geometry} material={materials.PalmLeaves} />
      </group>
    </group>
  )
}

useGLTF.preload(modelUrl)
